export default __webpack_public_path__ + "static/media/casaduana_bannerHome.fe506b97.jpg";